<template>
    <div class="results quiz-view-answers">
        <CurrentQuestion :currentQuestion="currentQuestion"></CurrentQuestion>
        <div class="content-view-answers-step-buttons content-quiz-buttons">
          <a href="#" class="prev-step" @click="previousQuestion" title="Previous Question" :class="{ 'disabled': disablePrevButton }"><span></span></a>
          <a href="#" class="next-step" @click="nextQuestion" title="Next Question" :class="{ 'disabled': disableNextButton }"><span></span></a>
        </div>
    </div>
</template>
<script>
import CurrentQuestion from "../components/current_question.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    CurrentQuestion
  },
  computed: {
    ...mapGetters(["currentQuestion", "questionIndex", "questionsLength"]),
    disablePrevButton() {
      return this.questionIndex === 0
    },
    disableNextButton() {
      return this.questionIndex === this.questionsLength - 1
    }
  },
  methods: mapActions({
    nextQuestion: "resultsNextQuestion",
    previousQuestion: "resultsPreviousQuestion"
  })
};
</script>
